/**
 * Enumeration for alignments
 * @enum {number}
 * @readonly
 */
export enum Alignment {
    /**
     * Align to bottom
     */
    Bottom,

    /**
     * Align to bottom left
     */
    BottomLeft,

    /**
     * Align to bottom right
     */
    BottomRight,

    /**
     * Align to center
     */
    Center,

    /**
     * Align to left
     */
    Left,

    /**
     * Align to right
     */
    Right,

    /**
     * Align to top
     */
    Top,

    /**
     * Align to top left
     */
    TopLeft,

    /**
     * Align to top right
     */
    TopRight,
}

export default Alignment;
